import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableRow, TableCell } from '@mui/material';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateVehicleModel from './ModalForUpdateVehicleModel';

const VehicleModelRow = ({
 vehicleModel,
  updateVehicleModel,
  deleteVehicleModel,
  dispatch,
  vehicleModelReducer,
  clearValidationErrors,
  brandReducer
}) => {
  const [show, setShow] = useState(false);

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteVehicleModel(id));
    };
    confirmDialog('obrišete model', action, ', obriši!');
  };

  const showModalUpdate = () => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (vehicleModel) => {
    dispatch(updateVehicleModel(vehicleModel, handlePreviewClose));
  };

  let row = (
    <>
      <TableRow>
        <TableCell>{vehicleModel.brand.brandName}</TableCell>
        <TableCell>{vehicleModel.modelName}</TableCell>

        <TableCell className="text-center" id="centerRow">
          <Link to="#" onClick={() => showModalUpdate()}>
            <i className="fas fa-edit fa-2x i" />
          </Link>
        </TableCell>
        <TableCell
          className={`text-center ${vehicleModel.id === 2 && 'disable-events'}`}
        >
          <Link to="#" id="deleteVehicleModel" onClick={() => onDeleteClick(vehicleModel.id)}>
            <i
              className={`fas fa-trash-alt fa-2x ${
                vehicleModel.id === 2 && 'disable-color'
              }`}
            />
          </Link>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      {row}

      {show && (
        <ModalForUpdateVehicleModel
          show={show}
          model={vehicleModel}
          updateVehicleModel={handleEdit}
          handleClose={handlePreviewClose}
          vehicleModelReducer={vehicleModelReducer}
       brandReducer={brandReducer}
          />
      )}
    </>
  );
};

export default VehicleModelRow;
